export default "__VITE_ASSET__CBlrTQ1O__"